let highchartsInitialized = false;
let HighchartsInstance = null;

export async function initializeHighcharts() {
    if (highchartsInitialized && HighchartsInstance) {
        return HighchartsInstance;
    }

    const [
        {default: Highcharts},
        {default: HighchartsMap},
        {default: HighchartsMore}
    ] = await Promise.all([
        import('highcharts/highcharts'),
        import('highcharts/modules/map'),
        import('highcharts/highcharts-more')
    ]);

    HighchartsMore(Highcharts);
    HighchartsMap(Highcharts);

    HighchartsInstance = Highcharts;
    highchartsInitialized = true;

    return HighchartsInstance;
}

export async function getHighchartsChart() {
    const Highcharts = await initializeHighcharts();
    const {Chart} = await import('highcharts-vue');
    return {Highcharts, Chart};
}